// extracted by mini-css-extract-plugin
module.exports = {"colorSecondary":"#5a7393","borderWidth":".125rem","inputBorderColor":"#b5e1e8","inputFocusBorderColor":"#63d9ec"};